export enum EditorMode {
  UPLOAD = 'UPLOAD',
  EDIT = 'EDIT'
}

export class EditorStateModel {
  editorMode: EditorMode = EditorMode.UPLOAD;
  selectedImage: string | null = null;
  isImageSelected: boolean = false;
  isFinishedEditing: boolean = false;
  isProcessingEdit: boolean = false;
  isProcessingOrder: boolean = false;
  isLoadingImage: boolean = false;
  base64Image: string = '';
  pdfBlob: Blob | null = null;
  isPortraitImage: boolean = false;

  get isEditMode(): boolean {
    return this.editorMode === EditorMode.EDIT;
  }

  get isUploadMode(): boolean {
    return this.editorMode === EditorMode.UPLOAD;
  }

  switchToEditMode(): void {
    this.editorMode = EditorMode.EDIT;
  }

  switchToUploadMode(): void {
    this.editorMode = EditorMode.UPLOAD;
  }

  reset(): void {
    this.editorMode = EditorMode.UPLOAD;
    this.selectedImage = null;
    this.isImageSelected = false;
    this.isFinishedEditing = false;
    this.isProcessingEdit = false;
    this.isProcessingOrder = false;
    this.isLoadingImage = false;
    this.base64Image = '';
    this.pdfBlob = null;
    this.isPortraitImage = false;
  }
}

